export default __webpack_public_path__ + "static/media/CI.c1a6a7d3.png";